module.exports = __webpack_public_path__ + "static/media/account-icon.ec9c9391.svg";